import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import DataState from '../../components/DataState';
import Lightbox from '../../components/Lightbox';
import VideoEmbed from '../../components/VideoEmbed';
import { mediaPicture } from '../../data/images';
import { useCollections } from '../../lib/api/collections';
import { useSeo } from '../../lib/seo';
import { publicFileUrl } from '../../lib/supabase';

const when = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : '');

const ProjectDetailsMain = () => {
  const { slug } = useParams();
  const content = useCollections('projects');
  const project = content.projects && content.projects.find((p) => p.id === slug);
  useSeo(project ? { title: project.seoTitle || `${project.title} | SANASA Campus`, description: project.seoDescription || project.summary } : null);

  if (content.loading || content.error) return <DataState state={content} />;
  if (!project) return <Navigate to="/projects" replace />;

  const photos = project.media.filter((m) => m.kind === 'image' && m.path).map((m) => ({ id: m.id, src: publicFileUrl('media', m.path), caption: m.caption }));
  const videos = [project.videoUrl, ...project.media.filter((m) => m.kind === 'video' && m.url).map((m) => m.url)].filter(Boolean);
  const documents = [
    ...(project.documentPath ? [{ id: 'main', name: 'Project document', url: publicFileUrl('brochures', project.documentPath) }] : []),
    ...project.media.filter((m) => m.kind === 'document' && m.path).map((m) => ({ id: m.id, name: m.caption || 'Document', url: publicFileUrl('brochures', m.path) })),
  ];
  const paragraphs = (project.body || '').split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);

  return (
    <main>
      <Breadcrumb title="Project Details" subTitle="Projects" />
      <div className="it-event-details-area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-9 col-lg-8">
              <div className="it-evn-details-wrap">
                <div className="sc-project-hero mb-35">
                  <img src={mediaPicture(project.imagePath)} alt="" />
                </div>
                <h4 className="it-evn-details-title">{project.title}</h4>
                <div className="postbox__meta">
                  {project.category && <span><i className="fa-light fa-tag"></i>{project.category}</span>}
                  {project.date && <span><i className="fa-light fa-calendar-days"></i>{when(project.date)}</span>}
                  {project.partner && <span><i className="fa-light fa-handshake"></i>{project.partner}</span>}
                </div>
                {project.summary && <div className="it-evn-details-text mb-30"><p><strong>{project.summary}</strong></p></div>}
                {paragraphs.map((p) => <div key={p} className="it-evn-details-text mb-20"><p>{p}</p></div>)}

                {videos.length > 0 && (
                  <div className="mt-40">
                    <h6 className="it-evn-details-title-sm pb-10">Video</h6>
                    {videos.map((v) => <div key={v} className="mb-20"><VideoEmbed url={v} title={project.title} /></div>)}
                  </div>
                )}
                {photos.length > 0 && (
                  <div className="mt-40">
                    <h6 className="it-evn-details-title-sm pb-10">Photos</h6>
                    <Lightbox images={photos} />
                  </div>
                )}
                {documents.length > 0 && (
                  <div className="mt-40">
                    <h6 className="it-evn-details-title-sm pb-10">Downloads</h6>
                    <ul className="sc-downloads">
                      {documents.map((d) => (
                        <li key={d.id}><a href={d.url} target="_blank" rel="noreferrer"><i className="fa-light fa-file-pdf"></i> {d.name}</a></li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="it-evn-sidebar-box it-course-sidebar-box">
                <Link className="ed-btn-square radius purple-4 w-100 text-center mb-20" to="/projects"><span>All Projects</span></Link>
                <Link className="ed-btn-square radius w-100 text-center" to="/contact"><span>Ask About This</span></Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProjectDetailsMain;
